export enum EmployeeDiscountItemSteps {
  Title,
  Type,
  Pin,
}
